// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css'; // Your custom CSS
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS
import './i18n'; // i18n setup
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // Make sure this import is active

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
serviceWorkerRegistration.register();
// Register the service worker for offline capabilities
// Note: You can also use serviceWorkerRegistration.unregister() to disable the service worker  